import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getAuth } from "firebase/auth";
import './AdminDashboard.css';
import { collection, getDoc, getDocs, doc, updateDoc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

import {
  fetchAllUsers,
  updateUserField,
  createUserManually,
} from "../logic/AdminUserLogic";
import { toast } from 'react-toastify';

const AdminManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [editStates, setEditStates] = useState({});
  const [newUser, setNewUser] = useState({ uid: "", pseudo: "", dp: 0, facebookLink: "" });
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [creatingUser, setCreatingUser] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      const usersData = await fetchAllUsers();
      setUsers(usersData);
    };
    loadData();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      user.getIdTokenResult(true).then((idTokenResult) => {
        if (!idTokenResult.claims.admin) {
          toast.info('⚠️ You are not recognized as an admin. Please log out and log back in.');
        }
      }).catch((err) => {
        // Removed: console.error("Error fetching ID token:", err);
      });
    }
  }, []);

  const handleSave = async (id) => {
    const updates = editStates[id];
    if (!updates) return;
    for (const field in updates) {
      await updateUserField(id, field, updates[field]);
    }
    const updatedUsers = await fetchAllUsers();
    setUsers(updatedUsers);
    setEditStates({});
  };

  const handleCreateUser = async () => {
    setCreatingUser(true);
    try {
      const { uid, pseudo, dp, facebookLink } = newUser;
      if (!uid || !pseudo) {
        toast.info('All fields are required.');
        return;
      }

      await createUserManually(uid, pseudo, dp, facebookLink);
      const updatedUsers = await fetchAllUsers();
      setUsers(updatedUsers);
      setNewUser({ uid: "", pseudo: "", dp: 0 });
      toast.success('✅ User created!');
    } catch (error) {
      toast.error('Error creating user: ' + error.message);
    } finally {
      setCreatingUser(false);
    }
  };

  return (
    <div className="admin-container admin-manage-users">
      <div className="admin-section">
        <h2>👥 Manage Users</h2>
        <button onClick={() => navigate('/admin-panelx-952504')}>
          ← Back to Dashboard
        </button>
      </div>

      <div className="form-grid">
        <div>
          <label>UID</label>
          <input value={newUser.uid} onChange={(e) => setNewUser({ ...newUser, uid: e.target.value })} />
        </div>
        <div>
          <label>Pseudo</label>
          <input value={newUser.pseudo} onChange={(e) => setNewUser({ ...newUser, pseudo: e.target.value })} />
        </div>
        <div>
          <label>DP</label>
          <input type="number" value={newUser.dp} onChange={(e) => setNewUser({ ...newUser, dp: Number(e.target.value) })} />
        </div>
        <div>
          <label>Facebook Link</label>
          <input value={newUser.facebookLink} onChange={(e) => setNewUser({ ...newUser, facebookLink: e.target.value })} />
        </div>
        <button onClick={handleCreateUser} disabled={creatingUser}>Create</button>
      </div>

      <h3>Edit Users ({users.length} Users) - Total DP: {users.reduce((total, user) => total + (user.dp || 0), 0).toLocaleString()}</h3>
      <table>
        <thead>
          <tr>
            <th>Pseudo</th>
            <th>UID</th>
            <th>DP</th>
            <th>Phone Number</th>
            <th>Facebook Link</th>
            <th>Division</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {[...users].sort((a, b) => (b.YP || 0) - (a.YP || 0)).map((u) => (

            <tr key={u.id}>
              <td>
                <input
                  value={editStates[u.id]?.pseudo ?? u.pseudo}
                  onChange={(e) =>
                    setEditStates({
                      ...editStates,
                      [u.id]: { ...editStates[u.id], pseudo: e.target.value }
                    })
                  }
                />
              </td>
              <td style={{ fontSize: '0.85em', color: '#888' }}>{u.id}</td>

              <td>
                <input
                  type="number"
                  value={editStates[u.id]?.dp ?? u.dp}
                  onChange={(e) =>
                    setEditStates({
                      ...editStates,
                      [u.id]: { ...editStates[u.id], dp: Number(e.target.value) }
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="tel"
                  value={editStates[u.id]?.phoneNumber ?? u.phoneNumber ?? ''}
                  onChange={(e) =>
                    setEditStates({
                      ...editStates,
                      [u.id]: { ...editStates[u.id], phoneNumber: e.target.value }
                    })
                  }
                  placeholder="0341234567"
                  maxLength="10"
                  style={{ width: '120px' }}
                />
              </td>
              <td>
                <input
                  value={editStates[u.id]?.facebookLink ?? u.facebookLink ?? ''}
                  onChange={(e) =>
                    setEditStates({
                      ...editStates,
                      [u.id]: { ...editStates[u.id], facebookLink: e.target.value }
                    })
                  }
                  placeholder="https://facebook.com/..."
                />
              </td>
              <td>
                {u.division}
              </td>

              <td>
                <button onClick={() => handleSave(u.id)}>Save</button>
                <button onClick={() => {
                  setSelectedUser(u);
                  setModalVisible(true);
                }}>Manage Profile</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalVisible && selectedUser && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Manage Profile – {selectedUser.pseudo}</h3>

            {/* Editable Stats */}
            <div className="field-group">
              <p>YP (Wins x2):{(selectedUser.stats?.wins || 0) * 2}</p> <br />
              <label>Matches</label>
              <input type="number" min="0" value={selectedUser.stats?.matches || 0}
                onChange={(e) => {
                  const value = Math.max(0, parseInt(e.target.value) || 0);
                  setSelectedUser(prev => ({
                    ...prev,
                    stats: { ...prev.stats, matches: value }
                  }));
                }}
              />
              <label>Wins</label>
              <input type="number" min="0" value={selectedUser.stats?.wins || 0}
                onChange={(e) => {
                  const value = Math.max(0, parseInt(e.target.value) || 0);
                  setSelectedUser(prev => ({
                    ...prev,
                    stats: { ...prev.stats, wins: value }
                  }));
                }}
              />

              <label>Losses</label>
              <input type="number" min="0" value={selectedUser.stats?.losses || 0}
                onChange={(e) => {
                  const value = Math.max(0, parseInt(e.target.value) || 0);
                  setSelectedUser(prev => ({
                    ...prev,
                    stats: { ...prev.stats, losses: value }
                  }));
                }}
              />
              <label>Champion 🏆</label>
              <input type="number" min="0" value={selectedUser.stats?.champion || 0}
                onChange={(e) => {
                  const value = Math.max(0, parseInt(e.target.value) || 0);
                  setSelectedUser(prev => ({
                    ...prev,
                    stats: { ...prev.stats, champion: value }
                  }));
                }}
              />

            </div>

            {/* Phone Number Management */}
            <div className="field-group">
              <label>Phone Number (MVola)</label>
              <input
                type="tel"
                value={selectedUser.phoneNumber || ''}
                onChange={(e) => {
                  setSelectedUser(prev => ({ ...prev, phoneNumber: e.target.value }));
                }}
                placeholder="0341234567"
                maxLength={10}
              />
              <small style={{ color: '#ffa726', fontSize: '0.85em' }}>
                ⚠️ Phone numbers are locked for users. Only admins can change them.
              </small>
            </div>

            {/* Rank & Division */}
            <div className="field-group">
              <label>Rank</label>
              <input
                type="number"
                min="0"
                value={selectedUser.rank || ''}
                onChange={(e) => {
                  const value = Math.max(0, parseInt(e.target.value) || 0);
                  setSelectedUser(prev => ({ ...prev, rank: value }));
                }}
              />

              <label>Division</label>
              <input value={selectedUser.division || ''}
                onChange={(e) => setSelectedUser(prev => ({ ...prev, division: e.target.value }))} />
            </div>

            <div className="modal-buttons">
              <button onClick={async () => {
                // Import validation utilities
                const { validateUserStats, calculateYP, validateStatValue } = await import('../utils/statsValidation');
                
                const stats = validateUserStats(selectedUser.stats);
                const calculatedYP = calculateYP(stats.wins);

                // Create backup before updating user data
                const { updateUserWithBackup } = await import('../utils/clientBackupWrapper');
                
                await updateUserWithBackup(selectedUser.id, {
                  rank: validateStatValue(selectedUser.rank, 'rank'),
                  division: selectedUser.division || '',
                  stats,
                  YP: calculatedYP
                }, 'admin_profile_update', {
                  previousRank: selectedUser.rank,
                  previousDivision: selectedUser.division,
                  previousStats: selectedUser.stats,
                  newStats: stats,
                  calculatedYP: calculatedYP
                });
                
                toast(`✅ Profile updated! YP set to ${calculatedYP}`);
                setModalVisible(false);
              }}>Save</button>

              <button onClick={() => setModalVisible(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminManageUsers; 